export const NETWORK_TONEN_OPTIONS_MAP = {
  kovan: [
    { value: 'WETH', label: 'Test WETH' },
    { value: 'USDC', label: 'Test USDC' },
  ],
}
